import { render, staticRenderFns } from "./LicenseApplicationComments.vue?vue&type=template&id=c88a76c2&scoped=true&"
import script from "./LicenseApplicationComments.vue?vue&type=script&lang=js&"
export * from "./LicenseApplicationComments.vue?vue&type=script&lang=js&"
import style0 from "./LicenseApplicationComments.vue?vue&type=style&index=0&id=c88a76c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88a76c2",
  null
  
)

export default component.exports